/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AnomalyDataPoint } from '../models/AnomalyDataPoint';

/**
* Time-series anomaly graph data for an evidence type
*/
export class AnomalyGraphData {
  /**
  * Ordered time-series data points
  */
  'dataPoints'?: Array<AnomalyDataPoint>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "dataPoints",
      "baseName": "dataPoints",
      "type": "Array<AnomalyDataPoint>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AnomalyGraphData.attributeTypeMap;
  }

  public constructor() {
  }
}

